import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { storePostLoginRedirect } from 'src/helpers/postLoginRedirect';

function AuthGuard({ children }) {
  const account = useSelector((state) => state.account);
  const location = useLocation();

  if (!account.user) {
    // Remember the /app page that was asked for (for example a texted link
    // to /app/verify) so sign-in can come back to it. Only safe
    // same-app /app paths are stored; anything else is ignored.
    storePostLoginRedirect(location?.pathname, location?.search);
    return <Redirect to="/login" />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
